import React, { memo } from 'react';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames/bind';
import styles from './Address.module.scss';

const cx = classNames.bind(styles);

const Address = (props) => {
	const { address, landAddress, postCd, onClick, buildingCd } = props;

	const handleClick = () => {
		onClick(buildingCd, postCd, address);
	};

	return (
		<li className={cx('li_address')}>
			<button
				type="button"
				onClick={handleClick}
				className={cx('divide_address')}
				data-enlog-dt-eventname="주소선택"
				data-enlog-dt-eventnamegroup="주소검색"
			>
				<span className={cx('post')}>(우){postCd}</span>
				<span className={cx('address')}>[도로명] {address}</span>
				<span className={cx('address')}>[지번] {landAddress}</span>
			</button>
		</li>
	);
};

export default memo(Address, isEqual);
